// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button {
	background-color: inherit;
	border: none; outline: none; box-shadow: none;
	margin:0; padding: 0;
	cursor: pointer;
}
button:disabled {cursor: not-allowed;}`, "",{"version":3,"sources":["webpack://./src/Theme/Components/button.css"],"names":[],"mappings":"AAAA;CACC,yBAAyB;CACzB,YAAY,EAAE,aAAa,EAAE,gBAAgB;CAC7C,QAAQ,EAAE,UAAU;CACpB,eAAe;AAChB;AACA,iBAAiB,mBAAmB,CAAC","sourcesContent":["button {\r\n\tbackground-color: inherit;\r\n\tborder: none; outline: none; box-shadow: none;\r\n\tmargin:0; padding: 0;\r\n\tcursor: pointer;\r\n}\r\nbutton:disabled {cursor: not-allowed;}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
